module.exports = __webpack_public_path__ + "img/circle-1-duotone.494486be.svg";